import React  from 'react'

const debug = false
// const debug = "FieldDate_GoalListView"

export default function FieldDate_GoalListView(props:any) {

    const value = props.field.getViewValue(props.model)

    const classes = Classes("ui5-txt-less-important-small no-wrap p-l-10 m-l-1", props.className)

    return (
        <div className={classes}>
            {props.field.getDisplayValue(value)}
        </div>
    );
}
